export default __webpack_public_path__ + "static/media/discussions.a47ff8d3.svg";